<!-- ListSelect.vue -->
<!-- Steamlined component to select an item based on the OfficeMD "List" model -->
<script lang="ts" setup>
    import vSelect from "vue-select"
import { IListItem } from "../../lib/Api/List";
import { computed } from "vue";

    const props = defineProps<{
        modelValue?: any,
        options?: IListItem[],
        disabled?: boolean
    }>();

    const emit = defineEmits<{
        "update:model-value": any|undefined,
        "updatedSelection": [item: IListItem|undefined]
    }>();    

    function emitValue(val: IListItem)
    {
        emit("update:model-value", val?.id);
        emit("updatedSelection", val);
    }

    const selectedOptionByModelValue = computed<IListItem|undefined>(() =>{
        return props.options?.find(opt => opt.id == props.modelValue);
    });
</script>

<template>
    <vSelect
        :modelValue="selectedOptionByModelValue"
        @update:modelValue="val => emitValue(val)"
        :options="props.options"
        :disabled="props.disabled"
        label="displayText">
            <template #selected-option="{displayText}">
                {{ displayText }}
            </template>     
            <template #option="option">
                <slot name="option" :option="option">
                    {{ (<IListItem>option).displayText }}
                </slot>
            </template>
    </vSelect>
</template>